import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { rewardLeaderboardTransaction } from "store/actions";
import Table from "components/Table";
import Columns from "./Columns";
import FormikForm from "components/shared/FormikForm";

const InputFieldsForSearch = [
  {
    name: "search",
    type: "text",
    label: "",
    placeholder: "Search...",
  },
];

const initialValuesForFilter = {
  search: "",
};

const List = ({ userDetails }) => {
  const dispatch = useDispatch();

  const { LeaderboardTransactionList, loading, totalLeaderboardTransaction } =
    useSelector(({ Game }) => Game);

  const [columns] = useState(Columns({})); // set once
  const [filter, setFilter] = useState({
    page: 1,
    limit: 10,
    order: -1,
    orderBy: "date_created_utc",
    search: "",
    userId: "",
  });

  // ⛔ No setColumns here → prevents infinite loop

  useEffect(() => {
    if (!userDetails?._id) return;

    // update userId first time
    setFilter((prev) => ({
      ...prev,
      userId: userDetails._id,
    }));
  }, [userDetails]);

  // 🔥 CALL API ONLY WHEN FILTER IS READY
  useEffect(() => {
    if (!filter.userId) return;
    dispatch(rewardLeaderboardTransaction({ data: filter }));
  }, [filter]);

  const handleFilterForm = (info) => {
    setFilter((prev) => ({
      ...prev,
      search: info.search,
      page: 1,
    }));
  };

  return (
    <div className="section-body">
      <div className="card">
        <div className="row justify-content-between">
          <div className="col-12">
            <div className="card-header">
              <FormikForm
                initialValues={initialValuesForFilter}
                onSubmit={handleFilterForm}
                loading={loading}
                inputFields={InputFieldsForSearch}
                buttonText={"Search"}
              />
            </div>
          </div>
        </div>
      </div>

      {LeaderboardTransactionList?.length > 0 && (
        <Table
          data={LeaderboardTransactionList}
          columns={columns}
          setFilter={setFilter}
          total={totalLeaderboardTransaction}
          filter={filter}
        />
      )}

      {!loading && LeaderboardTransactionList?.length === 0 && (
        <p style={{ textAlign: "center" }}>No Data Found</p>
      )}
    </div>
  );
};

export default List;
